export default __webpack_public_path__ + "static/media/github.2e215a98.svg";